<script>
	// Stores
	import IncomingBetStore from '@/Stores/IncomingBetStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let open = false;
	export let bet;

	const rejectReasons = [
		'Price Change',
		'Minimum bets only',
		'Event Suspended',
		'No bonus bets on promotions',
		'Event limit reached',
		'No multis',
		'Custom'
	];

	let element;
	let sending = false;
	let rejectReason = rejectReasons[0];
	let customRejectReason = '';

	$: open && element && element.focus();
	$: error = rejectReason === 'Custom' && !customRejectReason;

	function confirmClicked() {
		let reject_reason = rejectReason === 'Custom' ? customRejectReason : rejectReason;
		if (!reject_reason) return;
		sending = true;
		IncomingBetStore.rejectBet(bet, {
			reject_reason
		})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Reject Bet Failed',
					message: (e.error && e.error[0]) || 'Problem rejecting bet',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
				open = false;
			});
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Reject Bet</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<fieldset>
				<div class="my-2 space-y-2">
					{#each rejectReasons as reason, i}
						<div class="flex items-center">
							<input
								id={`reject-${i}`}
								checked={i === 0}
								name="reject_reason"
								type="radio"
								value={reason}
								on:change={() => (rejectReason = reason)}
								class="w-4 h-4 focus:outline-none"
							/>
							<label for={`reject-${i}`} class="block ml-3">{reason}</label>
						</div>
					{/each}
					{#if rejectReason === 'Custom'}
						<input
							type="text"
							bind:value={customRejectReason}
							class="form-input focus:outline-none"
							placeholder="Custom reject reason"
						/>
					{/if}
				</div>
			</fieldset>
			<LoadingButton
				on:click={confirmClicked}
				loading={sending}
				disabled={error}
				className="mt-4 mb-4 btn {error ? 'btn-primary-action-disabled' : 'btn-primary'}"
				>Reject
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel [esc]</button>
		</div>
	</Modal>
{/if}
